import { ChevronDown, ChevronRight, Clock } from 'lucide-react';
import { TimeRangeSelector } from './TimeRangeSelector';

interface TimeRangeSectionProps {
  endHour: number;
  onEndHourChange: (hour: number) => void;
  loading: boolean;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

export function TimeRangeSection({
  endHour,
  onEndHourChange,
  loading,
  expanded = false,
  onExpandedChange,
}: TimeRangeSectionProps) {
  const getTimeRangeLabel = (hours: number) => {
    if (hours === 24) return '1 Day';
    if (hours === 48) return '2 Days';
    if (hours === 72) return '3 Days';
    if (hours === 96) return '4 Days';
    if (hours === 120) return '5 Days';
    if (hours === 480) return '20 Days';
    if (hours === 1440) return '60 Days';
    return `${hours}h`;
  };

  return (
    <div>
      <button
        onClick={() => onExpandedChange && onExpandedChange(!expanded)}
        className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          {expanded ? (
            <ChevronDown className="h-4 w-4 text-gray-500" />
          ) : (
            <ChevronRight className="h-4 w-4 text-gray-500" />
          )}
          <div className="text-left">
            <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100">
              Forecast Horizon
            </h4>
            <p className="text-xs text-gray-500 dark:text-gray-400">{getTimeRangeLabel(endHour)}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <Clock className="h-3 w-3" />
          <span>{endHour}h</span>
        </div>
      </button>

      {expanded && (
        <div className="mt-2 pl-7">
          <TimeRangeSelector selected={endHour} onChange={onEndHourChange} disabled={loading} />
        </div>
      )}
    </div>
  );
}
